/* eslint-disable no-nested-ternary */
import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PendingRequestSkeleton from '../../skeletons/PendingRequestBoxSkeleton';
import { ASSIGN_DATA, REMOVE_REQUEST } from '../../../redux/pendingRequest.reducer';
import { getAllPendingRequest } from '../../../service/invite.service';
import PendingRequestCard from './PendingRequstCard';
import EmptyDashboardChart from '../../EmptyDashboardChart';

export default function PendingRequests() {
  const selectedOrg = useSelector((state) => state.org.selectedOrg);
  const orgLoading = useSelector((state) => state.org.orgLoading);
  const requestList = useSelector((state) => state.pendingRequest.request);
  const [loading, setLoading] = useState(requestList === null);
  const dispatch = useDispatch();

  const fetchRequestList = async () => {
    const res = await getAllPendingRequest(selectedOrg?.orgId ?? selectedOrg?.id);
    if (res) {
      dispatch({ type: ASSIGN_DATA, payload: { data: res } });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!orgLoading && requestList === null) {
      fetchRequestList();
    } else {
      setLoading(false);
    }
  }, [orgLoading]);

  const handleRemoveRequest = (id) => {
    dispatch({ type: REMOVE_REQUEST, payload: id });
  };

  return (
    <Grid container spacing={2}>
      {loading ? (
        [0, 1, 2, 3].map((_, index) => (
          <Grid item xs={12} md={6} key={index}>
            <PendingRequestSkeleton />
          </Grid>
        ))
      ) : requestList === null || requestList.length === 0 ? (
        <EmptyDashboardChart text="No request is there" />
      ) : (
        requestList.map((rl) => (
          <Grid item xs={12} md={6} key={rl.id}>
            <PendingRequestCard
              userDetail={rl.requesterUserId}
              requestData={rl}
              key={rl.id}
              id={rl.id}
              removeRequest={() => handleRemoveRequest(rl.id)}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
}
